import { Close, Icon } from "@shared/ui";
import toast from "react-hot-toast";

/**
 * Shared shell for loading toasts — renders the progress bar and message/close row.
 * Each toast component supplies its own `progress` value via `useProgressBar`.
 */
const ToastShell = ({ t, progress }) => (
  <div
    className={`flex flex-col bg-blue-600 text-white text-sm w-1/6 shadow-md rounded-md border-none ${
      t.visible ? "animate-toast-bounce-loop" : "animate-leave"
    }`}
  >
    <div className="px-1 pt-1">
      <div className="w-full h-1 rounded-full overflow-hidden bg-white/20">
        <div
          className="h-full bg-white rounded-full"
          style={{
            width: `${progress}%`,
            transition: t.completed
              ? "width 300ms ease-out"
              : "width 150ms linear",
          }}
        />
      </div>
    </div>
    <div className="flex items-start justify-between px-4 py-3">
      <p>{t.message}</p>
      <Icon
        icon={Close}
        className="flex-none translate-y-1 cursor-pointer transition hover:scale-110 fill-white"
        onClick={() => toast.dismiss(t.id)}
      />
    </div>
  </div>
);

export default ToastShell;
